/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
// Routes
import { canNavigate } from '@/libs/acl/routeProtection';
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
  checkRouter,
} from '@/auth/utils';
import cont_user from './routes/cont-user';
import cont_public from './routes/cont-public';
import core from './routes/core';
import { length } from './../@core/utils/validations/validations';
import store from '../store/index';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', redirect: { name: 'auth-login' } },
    ...core,
    ...cont_user,
    ...cont_public,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

router.beforeEach(async (to, _, next) => {
  // NProgress.start();

  const isLoggedIn = isUserLoggedIn();
  if (to.matched.some(record => record.meta.resource)) {
    if (isLoggedIn != null && to.meta.resource !== 'public') {
      await store.dispatch('masterData/fetchMenu');

      const userData = getUserData();
      router
        .push(getHomeRouteForLoggedInUser(userData ? userData.role : null))
        .catch(error => { });
    } else {
      next();
    }
  } else {
    if (!canNavigate(to)) {
      // Redirect to login if not logged in

      if (!isLoggedIn) return next({ name: 'auth-login' });

      if (to.meta.resource == 'Auth') {
        return next({ name: 'auth-login' });
      }

      // If logged in => not authorized
      return next({ name: 'error-404' });
    }

    if (isLoggedIn !== null) {
      if (to.meta.resource !== 'Auth') {
        const routerCheck = await checkRouter(to.name);

        if (routerCheck.length == 0 && to.name !== 'notifications')
          return next({ name: 'misc-not-authorized' });
      }
    }

    //   Redirect if logged in
    if (to.meta.redirectIfLoggedIn && isLoggedIn !== null) {
      // next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
      const userData = getUserData();

      router
        .push(getHomeRouteForLoggedInUser(userData ? userData.role : null))
        .catch(() => { });
    }
    // await store.dispatch('masterData/fetchMenu');
    return next();
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  // NProgress.done();
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
